import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TransactionsTableComponent } from "./transactions-table.component";
import { FlexLayoutModule } from "@angular/flex-layout";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MaterialModule } from "app/material.module";
import { PerfectScrollbarModule } from "ngx-perfect-scrollbar";
import { FileUploadModule } from "../file-upload/file-upload.module";
import { TypeSearchModule } from "../type-search/type-search.module";
import { DsSharedModule } from "app/shared/ds-shared.module";

@NgModule({
  declarations: [TransactionsTableComponent],
  exports: [TransactionsTableComponent],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    MaterialModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    FormsModule,
    FileUploadModule,
    TypeSearchModule,
    PerfectScrollbarModule,
    DsSharedModule,
  ],
})
export class TransactionsTableModule {}
